var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2426 2.19676C12.8514 2.06905 12.4338 2 12 2C10.955 2 10.0035 2.40076 9.29099 3.05697L10.5461 3.68451C11.0273 3.92513 11.6085 3.83081 11.989 3.45036L13.2426 2.19676Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38675 4.28196C8.13879 4.8025 8 5.38507 8 6.00006C8 7.61651 8.95883 9.00902 10.3388 9.63986C11.7024 6.54122 14.6331 5.75303 15.9923 5.75007C15.9236 4.63495 15.3979 3.64345 14.6003 2.96045L13.0496 4.51108C12.2126 5.34807 10.934 5.55557 9.87526 5.02621L8.38675 4.28196Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8282 9.99643C11.8851 9.99883 11.9424 10.0001 12 10.0001C13.7697 10.0001 15.271 8.85075 15.7983 7.25781C14.7903 7.33149 12.8535 7.95066 11.8282 9.99643Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5C15.0376 11.5 17.5 9.03757 17.5 6H19C20.1046 6 21 6.89543 21 8V19C21 19.5523 20.5523 20 20 20H12.75V15.8107L14.4697 17.5303C14.7626 17.8232 15.2374 17.8232 15.5303 17.5303C15.8232 17.2374 15.8232 16.7626 15.5303 16.4697L12.5303 13.4697C12.2374 13.1768 11.7626 13.1768 11.4697 13.4697L8.46967 16.4697C8.17678 16.7626 8.17678 17.2374 8.46967 17.5303C8.76256 17.8232 9.23744 17.8232 9.53033 17.5303L11.25 15.8107V20H4C3.44772 20 3 19.5523 3 19V8C3 6.89543 3.89543 6 5 6H6.5C6.5 9.03757 8.96243 11.5 12 11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDeployment);
export default __webpack_public_path__ + "static/media/software-deployment.1c0b165826d460492ab287cb25c57733.svg";
export { ForwardRef as ReactComponent };